import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';

export function initHighcharts(app) {
  /**
   * Highcharts custom legend color
   * http://jsfiddle.net/fypopsnc/5/
   */
  (function(H) {
    H.wrap(H.Legend.prototype, 'colorizeItem', function(proceed, item) {
      var color = item.color;
      if (item.options.legendColor) {
        item.color = item.options.legendColor;
      }
      proceed.apply(this, Array.prototype.slice.call(arguments, 1));
      item.color = color;
    });
  }(Highcharts));
  
  Highcharts.setOptions({
    colors: ["#7cb5ec", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1", "#434348"]
  });

  app.use(HighchartsVue);
} 